import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import type { FieldValidation } from '@rjsf/utils';
import FormControl from '@material-ui/core/FormControl';
import { FormHelperText } from '@material-ui/core';
import { useUsers } from '@developer-portal/plugin-devportal-org-hub';
import { Autocomplete } from '@material-ui/lab';
import TextField from '@material-ui/core/TextField';

/*
 This is the actual component that will get rendered in the form
*/
export const SelectUsersComponent = ({
  onChange,
  rawErrors,
  required,
  formData,
  schema,
}: FieldExtensionComponentProps<string[]>) => {
  const handleChange = (_event: any, value: any) => {
    onChange(value.map((user: any) => user.userNameShort));
  };

  const { value: users = [] } = useUsers();
  return (
    <FormControl margin="normal" required={required} error={rawErrors?.length > 0 && !formData}>
      <Autocomplete
        multiple
        id="select-users"
        options={users.sort((a, b) => a.userName.localeCompare(b.userName))}
        getOptionLabel={option => `${option.firstName} ${option.lastName} (${option.userNameShort})`}
        defaultValue={[]}
        onChange={handleChange}
        renderInput={params => <TextField {...params} variant="standard" />}
      />
      <FormHelperText>{schema.description?.toString() || 'Select users'}</FormHelperText>
    </FormControl>
  );
};

/*
 This is a validation function that will run when the form is submitted.
  You will get the value from the `onChange` handler before as the value here to make sure that the types are aligned\
*/

export const selectUsersValidation = (values: string[], validation: FieldValidation) => {
  if (!values.length) {
    validation.addError(`At least one user must be selected.`);
  }
};
